import { useAppTheme } from "@hooks/useAppTheme";
import { CardContainer } from "@memorang/ui";
import { useLocalSearchParams } from "expo-router";
import { useEffect } from "react";
import CustomTabs from "../../../../components/CustomTabs";
import useSessionStore from "../../hooks/useSessionStore";
import EMRTable from "./EMRTable";
import { useEMRStore } from "./useEMRStore";

const EMRCard = ({
	showTooltip,
}: {
	showTooltip?: boolean;
}) => {
	const { index } = useLocalSearchParams<{ index: string }>();
	const currentItemIndex = index ? Number.parseInt(index) - 1 : 0;

	const theme = useAppTheme();

	const {
		goldStandardData,
		userData,
		currentItemGoldStandard,
		updateFromSessionData,
	} = useEMRStore();

	const sessionItems = useSessionStore((state) => state.sessionItems);
	const itemStates = useSessionStore((state) => state.itemStates);

	const currentItem = sessionItems[currentItemIndex];
	const currentItemId = currentItem?.id;
	const currentItemState = itemStates?.get(currentItemId!);
	const isAnswered = currentItemState?.answered;

	useEffect(() => {
		updateFromSessionData(currentItemIndex);
	}, [currentItemIndex, updateFromSessionData]);

	const tabs = [
		{
			label: "My response",
			content: (
				<EMRTable
					data={userData}
					goldStandardData={goldStandardData}
					isUserData
					isAnswered={isAnswered}
					currentItemGoldStandard={currentItemGoldStandard}
					showTooltip={showTooltip}
				/>
			),
			icon: "account-edit-outline",
		},
		{
			label: "Expected response",
			content: (
				<EMRTable
					data={goldStandardData}
					isAnswered={isAnswered}
					currentItemGoldStandard={currentItemGoldStandard}
					showTooltip={showTooltip}
				/>
			),
			icon: "check-circle-outline",
		},
	];

	return (
		<CardContainer
			icon="clipboard-pulse-outline"
			title="Electronic medical record"
			subtitle={
				"Patient name: Mr. Chan | Age: 45 | Sex: Male | Appearance: Anxious and short of breath"
			}
		>
			<CustomTabs
				tabs={tabs}
				mode="fixed"
				backgroundColor={theme.colors.elevation.level1}
			/>
		</CardContainer>
	);
};

export default EMRCard;
